
export enum RegistrationState {
    NotRegistered = "Not Registered",
    RegistrationSuccessful = "RegistrationSuccessful",
  }